<template>
  <!--==================
    component used in tour add and edit page in photo selection part (gallery)
    ===============-->

  <!-- Modal -->
  <div
    class="modal fade"
    id="image-select-container"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header py-3">
          <h5 class="modal-title">
            Photo Gallery
            <span v-if="tourThumb">({{ photos.tourThumb.length }})</span>
            <span v-else-if="tourBanner">({{ photos.tourBanner.length }})</span>
            <span v-else-if="tourGallery">({{ photos.tourGallery.length }})</span>
            <span v-else-if="tourDestination">({{ photos.tourDestination[daySelector].length }})</span>
            <span v-if="this.galleryImagesInModal.length != 0 && tourGallery"
              >&nbsp;&nbsp;&nbsp;{{ this.galleryImagesInModal.length }} - image selected</span
            >
          </h5>

          <button
            v-if="this.galleryImagesInModal.length != 0 && tourGallery"
            @click="saveGallery()"
            type="button"
            class="btn btn-primary ml-5"
            aria-label="Close"
          >
            Select
          </button>

          <button @click="modalClose()" type="button" class="close" aria-label="Close">
            <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" v-if="tourThumb">
            <div
              v-for="(photo, index) in photos.tourThumb.slice(
                (pageNumber - 1) * imagePerPage,
                pageNumber * imagePerPage
              )"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 thumb"
            >
              <img
                @click="selectGallery($event)"
                v-lazy="{
                  src: photo.filepath,
                  error: require('@/assets/images/no-thumbnail-medium.jpg'),
                  loading: require('@/assets/images/no-thumbnail-medium.jpg'),
                }"
                class="zoom img-fluid c-pointer"
              />
            </div>
          </div>
          <paginate
            v-if="tourThumb && photos.tourThumb.length != 0"
            v-model="pageNumber"
            :page-count="Math.ceil(photos.tourThumb.length / imagePerPage)"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-link-class="'page-link'"
          />
          <div v-if="tourThumb && photos.tourThumb.length == 0">There are no images yet.</div>

          <div class="row" v-if="tourBanner">
            <div
              v-for="(photo, index) in photos.tourBanner.slice(
                (pageNumber - 1) * imagePerPage,
                pageNumber * imagePerPage
              )"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 thumb"
            >
              <img @click="selectGallery($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
            </div>
          </div>
          <paginate
            v-if="tourBanner && photos.tourBanner.length != 0"
            v-model="pageNumber"
            :page-count="Math.ceil(photos.tourBanner.length / imagePerPage)"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-link-class="'page-link'"
          />
          <div v-if="tourBanner && photos.tourBanner.length == 0">There are no images yet.</div>

          <div class="row" v-if="tourGallery">
            <div
              v-for="(photo, index) in photos.tourGallery"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 thumb position-relative"
            >
              <img
                @click="selectGallery($event)"
                v-lazy="{
                  src: photo.filepath,
                  error: require('@/assets/images/no-thumbnail-medium.jpg'),
                  loading: require('@/assets/images/no-thumbnail-medium.jpg'),
                }"
                class="img-fluid c-pointer"
              />
              <input
                type="checkbox"
                :value="photo.filepath"
                v-model="galleryImagesInModal"
                class="position-absolute top-0 right-0 mr-5 mt-3"
              />
            </div>
          </div>

          <!-- <div class="row" v-if="tourGallery">
            <div
              v-for="(photo, index) in photos.tourGallery.slice(
                (pageNumber - 1) * imagePerPage,
                pageNumber * imagePerPage
              )"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 thumb position-relative"
            >
              <img @click="selectGallery($event)" :src="photo.filepath" class="img-fluid c-pointer" />
              <input
                type="checkbox"
                :value="photo.filepath"
                v-model="galleryImagesInModal"
                class="position-absolute top-0 right-0 mr-5 mt-3"
              />
            </div>
          </div>
          <paginate
            v-if="tourGallery && photos.tourGallery.length != 0"
            v-model="pageNumber"
            :page-count="Math.ceil(photos.tourGallery.length / imagePerPage)"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-link-class="'page-link'"
          /> -->
          <div v-if="tourGallery && photos.tourGallery.length == 0">There are no images yet.</div>

          <div class="row" v-if="tourDestination">
            <div
              v-for="(photo, index) in photos.tourDestination[daySelector].slice(
                (pageNumber - 1) * imagePerPage,
                pageNumber * imagePerPage
              )"
              :key="index"
              class="col-lg-4 col-md-6 col-xs-6 thumb"
            >
              <img @click="selectGallery($event)" :src="photo.filepath" class="zoom img-fluid c-pointer" />
            </div>
          </div>
          <paginate
            v-if="tourDestination && photos.tourDestination[daySelector].length != 0"
            v-model="pageNumber"
            :page-count="Math.ceil(photos.tourDestination[daySelector].length / imagePerPage)"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :page-link-class="'page-link'"
          />
          <div v-if="tourDestination && photos.tourDestination[daySelector].length == 0">There are no images yet.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";

export default {
  data() {
    return {
      photos: { tourThumb: [], tourGallery: [], tourBanner: [], tourDestination: [[]] },
      filterDestination: [],
      tourThumb: true,
      tourBanner: false,
      tourGallery: false,
      tourDestination: false,
      daySelector: 0,
      selector: "",

      //for pagination
      pageNumber: 1,
      imagePerPage: 6,

      galleryImagesInModal: [],
    };
  },

  components: {
    Paginate,
  },

  computed: {
    ...mapGetters(["tourPhotos", "tourDayPhotos", "tourGalleryPhotos", "tourInnerPhotos"]),
  },

  mounted() {
    this.$eventHub.$on("gallery-photo-destination", (destination, day, replace) => {
      // emmit for day by day destination selection
      const dest = destination.toUpperCase().replace(" ", "_");
      this.filterPhoto(dest, day, replace);
    });

    this.$eventHub.$on("gallery-photos", (destination) => {
      // emmit for tour, banner and gallery selection
      const dest = destination.toUpperCase().replace(" ", "_");
      this.filterGalleryPhoto(dest);
    });

    this.$eventHub.$on("gallery-day-destination", (destination) => {
      // emmit for tour days add and remove selection for day by day photo

      if (destination == null) {
        // add new gallery destination
        this.photos.tourDestination.push([]);
      } else {
        // remove existing gallery destination
        this.photos.tourDestination.splice(destination, 1);
      }
    });

    this.$eventHub.$on("gallery", (selector, daySelector) => {
      // emmit for tour photo, tour banner and tour gallery selection

      this.selector = selector;
      this.daySelector = daySelector;

      if (this.selector == "tour-gallery") {
        this.tourGallery = true;
        this.tourThumb = false;
        this.tourBanner = false;
        this.tourDestination = false;
      } else if (this.selector == "tour-day-gallery") {
        this.tourDestination = true;
        this.tourGallery = false;
        this.tourThumb = false;
        this.tourBanner = false;
      } else if (this.selector == "tour-thumb") {
        this.tourThumb = true;
        this.tourGallery = false;
        this.tourBanner = false;
        this.tourDestination = false;
      } else {
        this.tourBanner = true;
        this.tourThumb = false;
        this.tourGallery = false;
        this.tourDestination = false;
      }
    });
  },

  methods: {
    ...mapActions(["fetchTourPhotos", "fetchTourDayPhotos", "fetchTourGalleryPhotos", "fetchTourInnerPhotos"]),

    async filterPhoto(destination, day, replace) {
      // day by day gallery photo
      await this.fetchTourDayPhotos(destination);
      const dayPhoto = this.tourDayPhotos;
      this.photos.tourDestination.splice(day, 1, dayPhoto);

      if (this.photos.tourDestination[day] == undefined) return;

      if (this.photos.tourDestination[day].length > 0) {
        $("#banner-photo-" + day).show();

        if (replace) {
          this.$eventHub.$emit("day-gallery-photo", "", day);
        }
      } else {
        $("#banner-photo-" + day).hide();
        $("#destination-text-" + day).show();
        this.$eventHub.$emit("day-gallery-photo", "", day);
      }
    },

    async filterGalleryPhoto(destination) {
      let fP = this;

      // general gallery photo
      if (!this.filterDestination.includes(destination)) {
        // avoiding duplicating destination photos
        this.filterDestination.push(destination);

        // tour thumb photos
        await this.fetchTourPhotos(destination);
        const thumbnail = this.tourPhotos;

        if (thumbnail.length > 0) {
          thumbnail.forEach(function (image) {
            // add destination image to gallery
            fP.photos.tourThumb.push(image);
          });

          fP.photos.tourThumb.sort(() => Math.random() - 0.5); // shuffle photo gallery array
        }

        // tour banner photos
        await this.fetchTourInnerPhotos(destination);
        const banner = this.tourInnerPhotos;

        if (banner.length > 0) {
          banner.forEach(function (image) {
            // add destination image to gallery
            fP.photos.tourBanner.push(image);
          });

          fP.photos.tourBanner.sort(() => Math.random() - 0.5); // shuffle photo gallery array
        }

        // tour gallery photos
        await this.fetchTourGalleryPhotos(destination);
        let gallery = this.tourGalleryPhotos;

        if (gallery.length > 0) {
          gallery.forEach(function (image) {
            // add destination image to gallery
            fP.photos.tourGallery.push(image);
          });

          fP.photos.tourGallery.sort(() => Math.random() - 0.5); // shuffle photo gallery array
        }
      }
    },

    selectGallery(e) {
      let image = e.target.src;

      if (this.selector == "tour-gallery") {
        this.selectTourGallery(image);
      } else if (this.selector == "tour-thumb") {
        this.selectTourThumb(image);
      } else if (this.selector == "tour-day-gallery") {
        this.tourBannerDay(image);
      } else {
        this.selectTourBanner(image);
      }

      this.pageNumber = 1;
    },

    selectTourThumb(image) {
      this.$eventHub.$emit("tour-gallery-photo", image);

      this.modalClose();
    },

    tourBannerDay(image) {
      let day = this.daySelector;
      this.$eventHub.$emit("day-gallery-photo", image, day);

      this.modalClose();
    },

    selectTourBanner(image) {
      this.$eventHub.$emit("banner-gallery-photo", image);

      this.modalClose();
    },

    selectTourGallery(image) {
      const pageNumber = this.pageNumber;
      if (this.galleryImagesInModal.includes(image)) {
        var index = this.galleryImagesInModal.indexOf(image);
        if (index !== -1) {
          this.galleryImagesInModal.splice(index, 1);
        }
        return;
      }
      this.galleryImagesInModal.push(image);
      this.pageNumber = pageNumber;
    },

    saveGallery() {
      this.$eventHub.$emit("add-gallery-photo", this.galleryImagesInModal);
      this.modalClose();
      this.galleryImagesInModal = [];
    },

    modalClose() {
      $("#image-select-container").modal("hide");
      this.pageNumber = 1;
    },
  },
};
</script>
<style scoped>
.pagination {
  justify-content: center;
}
.modal-body {
  max-height: 80vh;
  overflow-y: scroll;
}
</style>